import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Button,
} from "@mui/material";
import { useCart } from "../store/CartContext";

export default function ReviewOrderPage() {
  const { cartItems, clearCart } = useCart();

  const subtotal = cartItems.reduce((sum, item) => sum + item.price * (item.qty || 1), 0);
  const tax = subtotal * 0.07; // 7% estimated tax
  const total = subtotal + tax;

  const handlePlaceOrder = () => {
    // Later: Submit to API
    alert("Order placed!");
    clearCart();
    window.location.href = "/"; // Redirect to homepage
  };

  return (
    <Box p={2}>
      <Typography variant="h4" gutterBottom>
        Review Your Order
      </Typography>

      <List>
        {cartItems.map((item, index) => (
          <Box key={index}>
            <ListItem alignItems="flex-start">
              <ListItemText
                primary={`${item.name} x${item.qty || 1}`}
                secondary={
                  item.options
                    ? Object.entries(item.options)
                        .map(([k, v]) => `${v}`)
                        .join(", ")
                    : null
                }
              />
              <Typography variant="body1">
                ${(item.price * (item.qty || 1)).toFixed(2)}
              </Typography>
            </ListItem>
            <Divider />
          </Box>
        ))}
      </List>

      <Box mt={2}>
        <Typography>Subtotal: ${subtotal.toFixed(2)}</Typography>
        <Typography>Tax: ${tax.toFixed(2)}</Typography>
        <Typography variant="h6">Total: ${total.toFixed(2)}</Typography>
      </Box>

      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 3 }}
        onClick={handlePlaceOrder}
      >
        Place Order
      </Button>
    </Box>
  );
}
